import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    events: [],
    modelDefault: {
        id: null,
        bot_id: 1,
        message_id: 1,
        title: 'Событие',
        status: 'primary',
        start_time: 0,
        created_at: null,
        updated_at: 0,
        name: null,
        type_list: '1',
        sex: null,
        old: null,
        city: null,
        old_par: null,
        working: 0,
        event: 'start_message',
        method: null,
        params: null,
        text_found: 0,
        vote_id: null,
        text: null,
        keyboard_id: null,
        location: null,
        dont_parse_links: 0,
        user_in_group: 0,
        attachment: null,
        all_users: null,
        delivered: null,
        readed: null,
        platform: 'vk',
        group_ids: '',
        excepts: '',
        module_group_id: 0,
        rnd: -1,
        chain: null,
        sleep_chain: null,
        sleep_type: 0,
        find_type: 0,
        work: 1,
        words_to_find: null,
        error: '',
        replace_ref: 0,
        counter: 0
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
